export default "/_next/static/images/badge_membership_on-b5f66c64e12784a6eb41ea6b482ea1dd.png";